import type { ConflictKind } from '@/components/schedule/provider-appointment-card';
import {
  Appointment,
  APPOINTMENT_STATUS,
  AvailabilityBlock,
  AvailabilityInterval,
} from '@/types/appointment';
import { timeToMinutes, zonedMinutesOfDay, zonedWeekday } from '@/utils/format-appointment';

export const ACTIVE_APPOINTMENT_STATUS = [APPOINTMENT_STATUS.PENDING, APPOINTMENT_STATUS.CONFIRMED];

/**
 * Conflito de um agendamento ativo com a grade e os bloqueios de quem atende.
 * Na agenda da equipe, passe a grade e os bloqueios do profissional do horário.
 */
export function appointmentConflict(
  a: Appointment,
  grid: AvailabilityInterval[],
  blocks: AvailabilityBlock[],
): ConflictKind {
  if (!ACTIVE_APPOINTMENT_STATUS.includes(a.status)) return null;
  const startMs = new Date(a.startAt).getTime();
  const endMs = new Date(a.endAt).getTime();
  // Bloqueio tem prioridade.
  // Bloqueio sem data de fim é pausa: vale de startAt em diante.
  const inBlock = blocks.some(
    (b) =>
      new Date(b.startAt).getTime() < endMs && (!b.endAt || startMs < new Date(b.endAt).getTime()),
  );
  if (inBlock) return 'block';
  // Fora da grade: nenhum intervalo do dia contém [início, fim).
  const weekday = zonedWeekday(a.startAt);
  const startMin = zonedMinutesOfDay(a.startAt);
  const endMin = zonedMinutesOfDay(a.endAt) || 24 * 60;
  const covered = grid.some(
    (i) =>
      i.weekday === weekday &&
      timeToMinutes(i.startTime) <= startMin &&
      timeToMinutes(i.endTime) >= endMin,
  );
  return covered ? null : 'grid';
}
